<template>
	<div class="progress">
		<div class="bar" :style="'width:'+progress+'%'"></div>
		<p class="progress-text">
			<slot></slot>
		</p>
	</div>
</template>

<script>
	export default {
		name: 'inc.progressBar',
		props: {
			progress: {
				type: Number,
				required: true
			}
		}
	}
</script>